import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap }         from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor( private _http: HttpClient, private _router: Router ) { }

  refreshTokens(){
    const httpOptions = {
      headers: new HttpHeaders({'RefreshToken': 'Bearer ' + this.refreshToken})
    };
    return this._http.get<any>(environment.api+'/api/users/token', httpOptions).pipe(
      tap((res)=> {
        if(res.status){
          this.saveAccessToken(res.accessToken);
          this.saveRefreshToken(res.refreshToken);
        }
      })
    );
  }

  saveAccessToken(accessToken: string){
  	if(window.localStorage){
      localStorage.setItem('accessToken', accessToken);
  	}
  }

  saveRefreshToken(refreshToken: string){
    if(window.localStorage)
      localStorage.setItem('refreshToken', refreshToken);
  }

  saveRole(role: string){
    if(window.localStorage)
      localStorage.setItem('role', role);
  }

  login(loginInfo: any){
    return this._http.post<any>(environment.api+'/api/users/adminlogin', loginInfo);
  }

  logOut(){
    const httpOptions = {
      headers: new HttpHeaders({'RefreshToken': 'Bearer ' + this.refreshToken})
    };
    return this._http.get<any>(environment.api+'/api/users/logout', httpOptions)
  }

  clearStorage(){
    if(window.localStorage){
      localStorage.clear()
    }
  }

  get refreshToken(){
    if(window.localStorage){
      let tokenValue = localStorage.getItem('refreshToken');
      return tokenValue;
    }
    return null;
  }

  get accessToken(){
  	if(window.localStorage){
  		let tokenValue = localStorage.getItem('accessToken');
  		return tokenValue;
    }
    return null;
  }

  get role(){
  	if(window.localStorage){
  		let role = localStorage.getItem('role');
  		return role;
    }
    return null;
  }
}
